var GaTrackingCode = (process.env.NODE_ENV === 'main') ? 'UA-111433639-1' : 'NO_TRACKING'
export default {
  GA_TRACKING_CODE: GaTrackingCode
}



// WEBPACK FOOTER //
// ./src/constants/GoogleAnalyticsConfig.js